import { call, fork, put, select, take } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import apiService from '../../api/apiServices/apiService';
import {
  deleteParserError,
  deleteParserErrorFinished,
  loadParserErrors,
  loadParserErrorsFailed,
  setParserErrors,
} from './reducer';
import {
  selectParserErrors,
  selectParserErrorsPage,
  selectParserErrorsPageSize,
} from './selectors';
import i18n from '../../../i18n';

function errorMessage(reject: { payload?: { message?: string } }): string {
  return reject.payload?.message || i18n.t('admin_parser_errors_load_failed');
}

function* watchLoadParserErrors() {
  while (true) {
    yield take(loadParserErrors.type);
    const page: ReturnType<typeof selectParserErrorsPage> = yield select(selectParserErrorsPage);
    const pageSize: ReturnType<typeof selectParserErrorsPageSize> = yield select(
      selectParserErrorsPageSize,
    );

    const { success, reject } = yield call(
      [apiService, apiService.getParserErrors],
      page,
      pageSize,
    );

    if (success) {
      yield put(setParserErrors(success.payload));
    }
    if (reject) {
      const message = errorMessage(reject);
      yield put(loadParserErrorsFailed(message));
      toast.error(message);
    }
  }
}

function* watchDeleteParserError() {
  while (true) {
    const { payload }: ReturnType<typeof deleteParserError> = yield take(deleteParserError.type);
    const items: ReturnType<typeof selectParserErrors> = yield select(selectParserErrors);
    const page: ReturnType<typeof selectParserErrorsPage> = yield select(selectParserErrorsPage);
    const pageSize: ReturnType<typeof selectParserErrorsPageSize> = yield select(
      selectParserErrorsPageSize,
    );

    const { success, reject } = yield call([apiService, apiService.deleteParserError], payload);

    if (success) {
      toast.success(i18n.t('admin_parser_error_deleted'));
      const nextPage = items.length === 1 && page > 1 ? page - 1 : page;
      yield put(deleteParserErrorFinished());
      yield put(loadParserErrors({ page: nextPage, pageSize }));
    }
    if (reject) {
      yield put(deleteParserErrorFinished());
      toast.error(reject.payload?.message || i18n.t('admin_parser_error_delete_failed'));
    }
  }
}

export default function* parserErrorsSaga() {
  yield fork(watchLoadParserErrors);
  yield fork(watchDeleteParserError);
}
